import { ApolloCache } from '@apollo/client';

interface ResetPaginatedCacheQueriesParams {
  cache: ApolloCache<any>;
}

export const resetPaginatedCacheQueries = ({ cache }: ResetPaginatedCacheQueriesParams) => {
  // evict paginated queries so that queries with lists of entities will correctly refetch
  // if they were not active when a mutation fired that could update their results

  // used by casting Lists page(s)
  cache.evict({ id: 'ROOT_QUERY', fieldName: 'organizationProjects' });
  cache.evict({ id: 'ROOT_QUERY', fieldName: 'organizationProjectsGroups' });

  // used by reps profile all media, if changes were made on the main profile page
  // route: /reps/profile/:profileId/artist/:artistId/media
  cache.evict({ id: 'ROOT_QUERY', fieldName: 'searchMedia' });
  cache.evict({ id: 'ROOT_QUERY', fieldName: 'searchArtistMedia' });

  // used by open calls page
  cache.evict({ id: 'ROOT_QUERY', fieldName: 'getProjectOpenCallCustomization' });

  cache.gc();
};
